import React from 'react';
import { GiftIcon } from 'lucide-react';
import { offerAnchor } from '../data/content';
import { bonuses, pricing } from '../data/bonuses';
import { BonusCard } from './BonusCard';
import { Button } from './ui/Button';
export function Bonuses() {
  return <section id="bonuses" className="bg-blush-100 px-4 py-12 md:py-16" data-id="element-38" data-mp="asz34ehj8c2g">
      <div className="mx-auto max-w-3xl text-center" data-id="element-39" data-mp="fsv6cbienzgy">
        <GiftIcon className="mx-auto h-8 w-8 text-berry-600" aria-hidden="true" data-id="element-40" data-mp="1un3jmyou3xv" />
        <p className="mt-3 text-[11px] font-extrabold uppercase tracking-[.18em] text-berry-700 md:text-xs" data-id="element-41" data-mp="1wrhyyu7qlce">
          And that's not all...
        </p>
        <h2 className="mt-2 text-2xl font-black uppercase leading-tight text-plum-950 md:text-4xl" data-id="element-42" data-mp="3o2wtbkcik9oa">
          Get 5 additional bonus books — <span className="text-berry-600" data-id="element-43" data-mp="3t2snkrvesmqn">FREE!</span>
        </h2>
        <div className="mx-auto mt-4 max-w-2xl space-y-2 text-sm leading-relaxed text-muted md:text-base" data-id="element-44" data-mp="1mbjr531xkfvx">
          <p data-id="element-45" data-mp="1r8tbi4agq1cw">Your collection doesn't end with 50 crochet handbags.</p>
          <p data-id="element-46" data-mp="3idmytxc3p7g2">
            You'll also receive <strong className="text-plum-950" data-id="element-47" data-mp="3icvan7ku2bzt">55 additional patterns</strong> for beautiful,
            practical accessories you can make, personalize, and coordinate with your favorite bags.
          </p>
          <p data-id="element-48" data-mp="3r5ym5abx4ert">These are extra projects designed to add even more creative possibilities to your bundle.</p>
        </div>
      </div>

      <div className="mx-auto mt-8 max-w-3xl space-y-4" data-id="element-49" data-mp="2zfkh83lvucsa">
        {bonuses.map(bonus => <BonusCard key={bonus.number} bonus={bonus} data-id="element-50" data-mp="2ugh9gbeipsgm" />)}
        <div className="flex flex-col items-center justify-center rounded-2xl border-2 border-dashed border-berry-500 bg-white p-6 text-center" data-id="element-51" data-mp="2ui2749w4prip">
          <p className="text-[11px] font-extrabold uppercase tracking-wider text-muted" data-id="element-52" data-mp="33hfe8vws6409">
            Total listed value of the 5 bonus books
          </p>
          <span className="mt-1 text-3xl font-black text-muted line-through decoration-berry-600 decoration-4" data-id="element-53" data-mp="no6phimu76na">
            ${pricing.bonusValue} USD
          </span>
          <p className="mt-1 font-display text-lg font-black uppercase text-berry-600" data-id="element-54" data-mp="3chv39kmwh2k0">
            All 5 bonus books included free!
          </p>
          <p className="mt-1 text-sm font-semibold text-plum-950" data-id="element-55" data-mp="3hk3wmi3oq6mn">
            That's 55 Additional Crochet Projects at No Extra Cost.
          </p>
        </div>
        <div className="pt-4 text-center" data-id="element-56" data-mp="3qhebedfpodwb">
          <Button href={offerAnchor} size="lg" subtext="Claim $61 in bonus books at today's launch price" data-id="element-57" data-mp="3qgbki5ie2bge">
            Yes! Send me all 5 bonus books
          </Button>
        </div>
      </div>
    </section>;
}